/**
 * Affichage de la note moyenne chauffeur (SCRUM-76). Un chauffeur jamais noté
 * (`ratingsCount === 0`) renvoie `null` → l'UI affiche « Nouveau » plutôt que le
 * 5.0 par défaut. Sinon la note est formatée à une décimale avec virgule
 * décimale (locale fr-TN), ex. « 4,8 ».
 */
export function formatDriverRating(d: { rating: number; ratingsCount: number }): string | null {
  if (d.ratingsCount === 0) return null
  return d.rating.toFixed(1).replace('.', ',')
}
